// eslint-disable-next-line import/no-extraneous-dependencies
import * as PDFJS from 'pdfjs-dist';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.mjs';

PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const validatePassword = async ({ file, password }) => {
  if (!file) throw new Error('Missing file');
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const arrayBuffer = event.target.result;
      try {
        await PDFJS.getDocument({ data: arrayBuffer, password }).promise;
        resolve();
      } catch (error) {
        if (error.code === 1) {
          error.reason = 'NEED_PASSWORD';
          reject(error);
        } else if (error.code === 2) {
          error.reason = 'INVALID_PASSWORD';
          reject(error);
        }
      }
    };

    reader.readAsArrayBuffer(file);
  });
};
